export interface LogoProps {
  variant?: "full" | "mark";
  /** "inverse" is for brand-coloured and dark backgrounds: white wordmark and mark, brand-coloured "D". */
  tone?: "default" | "inverse";
  /** Sizes the mark (for example `size-12`). The default `size-8` applies only when no size class is passed. */
  className?: string;
}

// PLACEHOLDER mark. The real logo comes from the Payload Brand global.
function Mark({ className, label, inverse }: { className?: string; label?: string; inverse?: boolean }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
    >
      <rect width="32" height="32" rx="8" fill="currentColor" />
      <path
        d="M10 9h6.5a7 7 0 0 1 0 14H10V9Zm4 3.6v6.8h2.5a3.4 3.4 0 0 0 0-6.8H14Z"
        className={inverse ? "fill-brand-600" : "fill-white"}
        fillRule="evenodd"
      />
    </svg>
  );
}

const hasSize = (className: string) => /(^|\s)(size|h|w)-/.test(className);

/** Dawsco logo. Colour comes from `text-*` (currentColor); the wordmark uses font-heading. */
export default function Logo({ variant = "full", tone = "default", className = "" }: LogoProps) {
  const inverse = tone === "inverse";
  const colour = inverse ? "text-white" : "text-brand-600";
  const size = hasSize(className) ? "" : "size-8";
  if (variant === "mark") {
    return <Mark label="Dawsco" inverse={inverse} className={`${size} ${colour} ${className}`} />;
  }
  return (
    <span className={`inline-flex items-center gap-x-2 ${colour} ${className}`}>
      <Mark inverse={inverse} className="size-8" />
      <span className={`font-heading text-xl font-bold tracking-tight ${inverse ? "text-white" : "text-neutral-900"}`}>Dawsco</span>
    </span>
  );
}
